module.exports = __webpack_public_path__ + "img/64.70b72a4d.jpg";